import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Headerdash from "./head";
import Sidebar from "./sidebar";
import Recorder from "../pages/QuestionPage/recorder";
import ResultBox from "../pages/QuestionPage/ResultBox";
import ScoreCard from "../pages/QuestionPage/ScoreCard";
import SpacingBox from "../pages/QuestionPage/Spacing";
import HeadingPage from "../pages/QuestionPage/Heading";
import useFetchData from "./fetchpostData";
import ScoreBox from "../pages/QuestionPage/ResponseBox";
import Notification from "../pages/QuestionPage/Notification";
import QuestionBox from "../pages/QuestionPage/questionbox";
import Timers from "./PageComponent/Timers";

export default function OpenquestionPage(props) {
  const { title } = useParams();
  const section = "readaloud";
  const practiceItemId = title;

  const post = useFetchData(section, title);
  const [originalWords, setOriginalWords] = useState("");
  const [loading, setLoading] = useState(false);
  const [text, setText] = useState("");
  const [isAttempted, setIsAttempted] = useState(false);
  const [message, setMessage] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const [notificationType, setNotificationType] = useState("");
  const [savedPractice, setSavedPractice] = useState(null);
  const [result, setResult] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [recordedBlob, setRecordedBlob] = useState(null);

  useEffect(() => {
    if (post && post.question) {
      setOriginalWords(post.question);
    }
  }, [post]);

  const savePractice = async (practiceData) => {
    try {
      const response = await fetch("/api/save-readaloud", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(practiceData),
      });
      if (!response.ok) throw new Error("Failed to save practice data");
      return await response.json();
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  };

  useEffect(() => {
    const highlightMatchingWords = () => {
      const words1 = originalWords.split(" ");
      const words2 = text.split(" ");
      setResult(
        words2.map((word2, index) => (
          <span
            key={index}
            style={{
              backgroundColor: words1.includes(word2) ? "#CBFB8A" : "#E74C3C",
              marginRight: "4px",
            }}
          >
            {word2}
          </span>
        ))
      );
    };
    highlightMatchingWords();
  }, [originalWords, text]);

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);

  //   const practiceData = {
  //     practiceType: section,
  //     practiceItemId,
  //     response: { questionId: practiceItemId, answer: text, isAttempted },
  //   };
  //   try {
  //     const result = await savePractice(practiceData);
  //     setMessage("Practice data saved successfully!");
  //     setNotificationType("success");
  //     setSavedPractice(result);
  //     setShowNotification(true);
  //     setTimeout(() => {
  //       setIsAttempted(true);
  //       setLoading(false);
  //       setSubmitted(true);
  //     }, 2000);
  //   } catch (error) {
  //     setMessage("Failed to save practice data.");
  //     setNotificationType("error");
  //     setShowNotification(true);
  //     setLoading(false);
  //     setSubmitted(false);
  //   }
  // };
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  
  //   if (!recordedBlob) {
  //     alert("Please record audio first before submitting.");
  //     return;
  //   }
  
  //   setLoading(true);
  
  //   try {
  //     // 1️⃣ First transcribe the recorded audio
  //     const formData = new FormData();
  //     formData.append("audio", recordedBlob, "recording.wav");
  
  //     const res = await fetch("/api/transcribe", {
  //       method: "POST",
  //       body: formData,
  //     });
  //     const data = await res.json();
  //     const transcribedText = data.text;
  //     setText(transcribedText);
  
  //     // 2️⃣ Then send to your save API
  //     const practiceData = {
  //       practiceType: section,
  //       practiceItemId,
  //       response: { questionId: practiceItemId, answer: transcribedText, isAttempted },
  //     };
  
  //     const result = await savePractice(practiceData);
  //     setMessage("Practice data saved successfully!");
  //     setNotificationType("success");
  //     setSavedPractice(result);
  //     setShowNotification(true);
  
  //     setTimeout(() => {
  //       setIsAttempted(true);
  //       setLoading(false);
  //       setSubmitted(true);
  //     }, 2000);
  //   } catch (error) {
  //     console.error("Error:", error);
  //     setMessage("Failed to save practice data.");
  //     setNotificationType("error");
  //     setShowNotification(true);
  //     setLoading(false);
  //     setSubmitted(false);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!recordedBlob) {
      alert("Please record audio first before submitting.");
      return;
    }
  
    setLoading(true);
  
    try {
      // ----------------------------
      // 1️⃣ Upload audio to DigitalOcean
      // ----------------------------
      const audioForm = new FormData();
      audioForm.append("audio", recordedBlob, "recording.wav");
  
      const uploadRes = await fetch("/api/upload-audio", {
        method: "POST",
        body: audioForm,
      });
  
      if (!uploadRes.ok) {
        throw new Error("Audio upload failed");
      }
  
      const uploadData = await uploadRes.json();
  
      if (!uploadData.audioUrl) {
        throw new Error("Audio URL missing from upload response");
      }
  
      const audioUrl = uploadData.audioUrl;
  
  
      // ----------------------------
      // 2️⃣ Transcribe audio
      // ----------------------------
      const transcribeForm = new FormData();
      transcribeForm.append("audio", recordedBlob, "recording.wav");
  
      const transRes = await fetch("/api/transcribe", {
        method: "POST",
        body: transcribeForm,
      });
  
      if (!transRes.ok) {
        throw new Error("Transcription request failed");
      }
  
      const transData = await transRes.json();
  
      if (!transData.text) {
        throw new Error("Transcription failed to return text");
      }
  
      const transcribedText = transData.text;
      setText(transcribedText); // update UI
  
  
      // ----------------------------
      // 3️⃣ Save practice (send to your scoring API)
      // ----------------------------
      const practiceData = {
        practiceType: section,
        practiceItemId,
        response: {
          questionId: practiceItemId,
          audioUrl: audioUrl,
          answer: transcribedText,
          isAttempted: true,
        },
      };
  
      const result = await savePractice(practiceData);
  
      setMessage("Practice data saved successfully!");
      setNotificationType("success");
      setSavedPractice(result);
      setShowNotification(true);
  
      setTimeout(() => {
        setIsAttempted(true);
        setLoading(false);
        setSubmitted(true);
      }, 1000);
    } catch (error) {
      console.error("Submit error:", error);
      setMessage(error.message || "Something went wrong.");
      setNotificationType("error");
      setShowNotification(true);
  
      setLoading(false);
      setSubmitted(false);
    }
  };
  
  
  
  return (
    <div>
      <Headerdash />
      <Sidebar />
      <div className="relative md:left-72 left-0 md:ml-3 top-28 bg-gray-100 h-auto w-full md:w-[1150px] rounded-sm p-4 ">
        <HeadingPage
          title={post?.q_title}
          timer={<Timers initialSeconds={0} />} // Use the Timer component here
          difficulty="Medium"
          attempted={isAttempted ? "Attempted" : "Not Attempted"}
        />

        <h3 class="mx-auto px-4 text-base sm:text-lg md:text-xl lg:text-lg leading-relaxed">
          Look at the text below. In the 35 seconds, you must read this text
          aloud as naturally and clearly as possible. You have 35 seconds to
          read aloud.
        </h3>
        <div className="flex justify-center lg:justify-center w-full">
          <Recorder
            text={text}
            setText={setText}
            onRecordingComplete={(blob) => setRecordedBlob(blob)} // ✅ Get blob from child
            {...props}
            duration={35}
            className="mt-5 mb-5 bg-gray-100 w-[440px] h-56 border-4"
          />
        </div>

        <QuestionBox question={post?.question} />
        <button
          className="bg-blue-800 hover:bg-blue-500 text-white font-semibold py-2 px-10 rounded-sm mt-3 ml-1 w-full max-w-[345px] sm:w-auto sm:ml-6"
          onClick={handleSubmit}
        >
          {loading ? (
            <span className="flex items-center justify-center">
              <svg
                className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              <span>Submitting...</span>
            </span>
          ) : (
            "Submit"
          )}
        </button>
        {submitted && (
          <>
            <ResultBox result={result} />
            <ScoreCard
              finalScore={savedPractice?.savedResponse?.totalScore}
              remarks={savedPractice?.savedResponse?.remarks}
              contentScore={savedPractice?.savedResponse?.contentScore}
              fluencyScore={savedPractice?.savedResponse?.fluencyScore}
              pronounctionScore={
                savedPractice?.savedResponse?.pronounctionScore
              }
            />
          </>
        )}
        <ScoreBox
          originalWords={originalWords}
          practiceItemId={practiceItemId}
          onIsAttempted={setIsAttempted}
        />
        <SpacingBox />
      </div>
      {showNotification && (
        <Notification
          message={message}
          type={notificationType}
          onClose={() => setShowNotification(false)}
        />
      )}
    </div>
  );
}
